<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="7em" class="baseInfoForm">
            <el-form-item label="证书类型" prop="type">
                <div class="moreRadio">
                    <el-radio v-model="form.type" v-for="item in typeOptions" :key="item.id" :label="item.label" border>{{ item.label }}</el-radio>
                </div>
            </el-form-item>
            <el-form-item label="证书名称" prop="name">
                <div v-if="nameInputType">
                    <el-select
                            v-model="form.name"
                            filterable
                            allow-create
                            maxlength="30"
                            default-first-option
                            placeholder="请选择/输入证书名称">
                        <el-option
                                v-for="item in certNameOptions"
                                :key="item.id"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div v-else>
                    <el-input v-model="form.name" maxlength="30" placeholder="请输入证书名称"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="获得时间" prop="getTime">
                <el-date-picker
                        v-model="form.getTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="证书附件">
                <div v-if="form.attachment" class="upImg" style="height:200px">
                    <img :src="imageLocation(form.attachment)" />
                    <el-button type="text" @click="deleteAttachment" icon="el-icon-delete"></el-button>
                </div>
                <div class="uploaderDiv">
                    <uploader ref="uploader" :options="uploaderOptions" @file-added="fileAdded" @file-success="handleUploadSuccess">
                        <uploader-unsupport></uploader-unsupport>
                        <div class="uploader-files">
                            <slot :files="files">
                                <ul>
                                    <li v-for="(file,i) in files" :key="file.id">
                                        <div class="upImg" style="height:200px">
                                            <img :src="previewPictures(file)">
                                            <el-button @click="deleteAttachmentFile(i)" icon="el-icon-delete"></el-button>
                                        </div>
                                        {{file.name}}
                                    </li>
                                </ul>

                            </slot>
                        </div>
                        <uploader-btn :attrs="attrs" class="el-button el-button--default is-plain" v-if="files.length==0 && !form.attachment"><i
                                class="el-icon-circle-plus-outline"></i>上传附件
                        </uploader-btn>
                    </uploader>
                </div>
                <input type="hidden" v-model="form.attachment">
                <div class="uploadTxt">支持上传一张JPG、JPEG、PNG格式图片，文件不可大于10MB</div>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="updateCert()" v-if="editStatus.status">更新保存</el-button>
                <el-button type="primary" @click="saveCert()" v-else>保存</el-button>
                <el-popconfirm title="确认取消编辑？"
                    @confirm="cancel()"
                    placement="top-start"
                    icon="el-icon-info"
                    icon-color="red"
                    class="ml10">
                    <el-button slot="reference">取消</el-button>
                </el-popconfirm>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {mergeFile} from '@/api/file';
    import {saveCert,updateCert} from '@/api/resume';
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        name: 'certForm',
        props: ['form','resumeId','editStatus'],
        data() {
            return {
                rules: {
                    type: [
                        {required: true, message: '请选择证书类型'},
                    ],
                    name: [
                        {required: true, message: '请输入证书名称'},
                        {pattern: /^\S+$/, message: '支持输入中英文、数字和特殊字符'},
                        {max: 30, message: '字符长度不超过30'}
                    ]
                },
                typeOptions: [],    // 证书类型
                // 证书名称选项参数
                certNameOptions: [
                    {value: '大数据应用开发(Python)', label: '大数据应用开发(Python)'},
                ],
                // 当证书类型为‘1+x技能证书’时，证书名称选项参数
                PythonCertNameOptions: [
                    {value: '大数据应用开发(Python)', label: '大数据应用开发(Python)'},
                ],
                // 当证书类型为‘CBDA技能证书’时，证书名称选项参数
                CBDACertNameOptions: [
                    {value: '大数据分析工程师', label: '大数据分析工程师'},
                    {value: '大数据开发工程师', label: '大数据开发工程师'},
                    {value: '人工智能工程师', label: '人工智能工程师'},
                ],
                // 当证书类型为‘微班级证书’时，证书名称选项参数
                classCertNameOptions: [
                    {value: '微班级证书', label: '微班级证书'},
                ],
                // 当证书类型为‘工信部证书’时，证书名称选项参数
                ministryCertNameOptions: [
                    {value: 'Python技术应用工程师（高级）', label: 'Python技术应用工程师（高级）'},
                    {value: 'Python技术应用工程师（中级）', label: 'Python技术应用工程师（中级）'},
                    {value: 'Python技术应用工程师（初级）', label: 'Python技术应用工程师（初级）'},
                    {value: '大数据技术应用（高级）', label: '大数据技术应用（高级）'},
                    {value: '大数据技术应用（中级）', label: '大数据技术应用（中级）'},
                    {value: '大数据技术应用（初级）', label: '大数据技术应用（初级）'},
                ],
                // uploader组件文件上传参数
                uploaderOptions: {
                    target: '/api/file/chunk',
                    chunkSize: '1048576',
                    testChunks: true,
                    checkChunkUploadedByResponse: this.checkChunkUploadedByResponse,
                },
                // uploader组件上传证书附件文件类型限制
                attrs: {
                    accept: '.jpg, .jpeg, .png'
                },
                // uploader组件文件上传校验
                validateFile: {
                    accept: '.jpg, .jpeg, .png',
                    limit: 1,
                    totalSize: 10,
                    tip: '可上传1个文件，总大小不超过10MB'
                },
                // 附件文件Id
                attachmentFileId: '',
                // 附件文件上传对象
                files: [],
                // 附件名称输入类型：选择框/输入框
                nameInputType: true,
            }
        },
        watch: {
            // 监听证书类型实现证书名称选择项相对应的改变
            'form.type'(newValue, oldValue) {
                if(this.form.name) {
                    this.form.name = undefined;
                }
                this.changeFormType(newValue)
            }
        },
        created() {
            this.changeFormType(this.form.type)
            this.loadDictData();
        },
        computed: {
            imageLocation(){
                return function (file){
                    let imagePath = encodeURI(file);
                    return `/files?imagePath=${imagePath}`;
                }
            }
        },
        methods: {
            changeFormType(formType) {
                this.nameInputType = true;
                if (formType == '1+x技能证书') {
                    this.certNameOptions = this.PythonCertNameOptions;
                }else if (formType == 'CBDA技能证书'){
                    this.certNameOptions = this.CBDACertNameOptions;
                }else if (formType == '微班级证书'){
                    this.certNameOptions = this.classCertNameOptions;
                }else if(formType == '工信部证书') {
                    this.certNameOptions = this.ministryCertNameOptions;
                } else {
                    this.nameInputType = false;
                }
            },
            /** 获取字典数据 */
            loadDictData() {
                getTreeListByDictType("certificate_type").then(response => {
                    this.typeOptions = response.data;
                    this.PythonCertNameOptions = response.data.filter(item => item.label == "1+x技能证书")[0].children
                    this.CBDACertNameOptions = response.data.filter(item => item.label == "CBDA技能证书")[0].children
                    this.classCertNameOptions = response.data.filter(item => item.label == "微班级证书")[0].children
                    this.ministryCertNameOptions = response.data.filter(item => item.label == "工信部证书")[0].children
                });
            },
            saveCert() {
                this.$refs["form"].validate(valid=> {
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        saveCert(this.form).then(res => {
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历证书保存失败");
                        });
                    }
                })
            },
            updateCert() {
                this.$refs["form"].validate(valid=> {
                    if (valid) {
                        this.form.resumeId = this.resumeId;
                        updateCert(this.form).then(res => {
                            this.cancel();
                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历证书保存失败");
                        });
                    }
                })
            },
            // 简历工作经历表单取消编辑状态
            cancel() {
                this.editStatus.id = 0;
                this.editStatus.status = false;
                this.$emit('editStatus', this.editStatus);
                this.$store.commit('changeResumeEditStatus', false);
                this.$store.commit('changeCertEditStatus', false);
            },
            /** 预览附件照片*/
            previewPictures(file){
                return window.URL.createObjectURL(file.file);
            },
            deleteAttachment() {
                if (this.form.attachment) {
                    this.form.attachment = '';
                }
            },
            deleteAttachmentFile(i) {
                this.files.splice(i, 1);
            },
            validateFilename(filename){
                return /^[\u4e00-\u9fa5a-zA-Z0-9-_.]{1,20}$/.test(filename);
            },
            fileAdded(file) {
                let time = new Date().getTime();
                file.name = time + file.name.substring(file.name.indexOf("."));
                file.uniqueIdentifier = time;
                const uploader = this.$refs.uploader.uploader;
                const limit = this.validateFile.limit;
                const maxSize = 1024 * 1024 * this.validateFile.totalSize;
                const accept = this.validateFile.accept;

                const already = uploader.files.find(x => x.name === file.name);
                if(already){
                    file.ignored = true;
                    this.$message.error('请不要重复上传相同文件');
                    file.cancel()
                    return;
                }
                if (accept.indexOf(file.name.substring(file.name.lastIndexOf('.'))) === -1) {
                    file.ignored = true;
                    this.$message.error(`文件格式不符合要求，请上传${accept}格式文件`);
                    return;
                }
                if (uploader.files.length >= limit) {
                    file.ignored = true;
                    this.$message.error(`上传的文件总数不能大于${limit}`);
                    return;
                }
                if (file.size > maxSize) {
                    file.ignored = true;
                    this.$message.error(`文件大小不能超过${this.validateFile.totalSize}MB`);
                    return;
                }
            },
            /** 分块文件上传*/
            checkChunkUploadedByResponse(chunk, message) {
                let res = JSON.parse(message);
                if (Array.isArray(res.data)) {
                    let chunkNumbers = res.data;
                    return (chunkNumbers || []).indexOf(chunk.offset + 1) >= 0;
                } else {
                    if (null === res.data) {
                        return false;
                    } else {
                        chunk.file.itemId = res.data;
                        return true;
                    }
                }
            },
            /** 分块文件上传完毕，合并分块文件，返回文件id*/
            async handleUploadSuccess(rootFile, file, message, chunk) {
                let res = JSON.parse(message);
                if (res.data && res.data === true) {
                    console.log('分块上传完成，开始合并...')
                    mergeFile(file).then((res) => {
                        console.log("文件合并完成");
                        this.form.fileId = res.data.fileId;
                        this.files = this.$refs.uploader.files;
                    }).catch(() => {

                    })
                }
            }
        }
    }
</script>
